module.exports = __webpack_public_path__ + "img/sp-chat-icon.910f326b.png";